import { Row } from 'antd';
import styled from 'styled-components';
export const WrapContent = styled.p`
  white-space: pre-wrap;
`;
export const ProjectTitle = styled.p`
  font-size: 20px;
`;
const getDetailColor = type => {
  switch (type) {
    case 'danger':
      return '#d0021b';
    case 'info':
      return '#096dd9';
    default:
      return '#98a9bc';
  }
};
export const DetailValue = styled.span`
  color: ${props => getDetailColor(props.type)};
  font-weight: 700;
`;
export const DetailKey = styled.span`
  color: ${props => getDetailColor(props.type)};
`;
export const DetailValueDiv = styled.div`
  font-weight: 700;
`;
export const DetailInfo = styled.div`
  display: flex;
  flex-direction: column;
`;
export const DetailSection = styled.div`
  color: #98a9bc;
  display: flex;
  justify-content: space-between;
`;
export const DescriptionTitle = styled.div`
  display: flex;
  font-weight: 300;
  justify-content: space-between;
  line-height: 1;
  margin-bottom: 10px;
  margin-top: 21px;
  word-break: break-all;

  @media (max-width: 767px) and (max-width: 411px) {
    & {
      display: inline-block;
    }
  }
`;
export const TagAndActionBtn = styled.div`
  margin-top: 20px;
`;
export const TagRow = styled(Row)`
  .ant-tag {
    align-items: center;
    display: flex;
    height: 32px;
    line-height: 16px;
    margin-bottom: 0px;
    margin-right: 0px;
    padding: 8px 12px;
  }

  .tag-item {
    height: 32px;
    margin-bottom: 8px !important;
    margin-right: 8px;
    width: fit-content !important;
  }
`;
export const LeftPanel = styled.div`
  background: #ffffff;
  border-radius: 4px;
  max-width: 840px;
  z-index: 1;
`;
export const LabelSpan = styled.span`
  font-weight: 300;
`;
export const Label = styled.div`
  font-weight: 300;
  margin-bottom: 10px;
  margin-top: 18px;
`;
export const DescriptionSection = styled.div`
  word-break: break-all;
`;
export const PricingDetail = styled.div`
  justify-content: space-between;
  .ant-row {
    margin-bottom: 10px;
  }
`;